import AppForm from '../app-components/Form/AppForm';

Vue.component('app-finances-report-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                admin_user_id:  '' ,
                app_offices_id:  '' ,
                app_factories_id:  '' ,
                name:  '' ,
                type:  '' ,
                money:  '' ,
                rest_money:  '' ,
                finance_code:  '' ,
                ref_id:  '' ,
                
            }
        }
    }

});